(function () {

// SELECTORS
  const selectors = {
    sidebarSection: '.custom-sidecart-section',
    sidebarContainer: '.custom-sidecart',
    sidebarQty: 'sidecart-qty',
    headerCartButton: '.site-header-cart--button',
    closeSidebarElement: '[data-close-sidebar]',
    orderNoteBlock: '.custom-sidecart-ordernote',
    orderNoteOpen: '.custom-sidecart__ordernote-open',
    orderNoteClose: '[data-close-ordernote]',
    addToSidecart: 'data-add-to-sidecart',
    formError: '.product-form-error',
    removeProduct: 'data-remove-item',
    qtyInput: '[data-quantity-input]',
    tooltipMaximum: '[data-tooltip-maximum]',
    orderNoteSave:'[data-save-ordernote]',
  };


// GET SCROLLBAR WIDTH
  let scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  window.addEventListener('resize', () => {
    scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  }, true);


// OPEN SIDECART
  const openSidebar = (e) => {
    if (e) {
      e.preventDefault();
    }
    document.querySelector('body').classList.add('sidebar-opened');
    document.querySelector(selectors.sidebarSection).classList.add('is-open');
    document.querySelector('html').style.paddingRight = scrollbarWidth + 'px';
  }


// CLOSE SIDECART
  const closeSidebar = (e) => {
    e.preventDefault();
    document.querySelector('body').classList.remove('sidebar-opened');
    document.querySelector(selectors.sidebarSection).classList.remove('is-open');
    document.querySelector('html').style.paddingRight = 0;
  }


// SHOW ERROR
  const showError = (el, desc) => {
    let errorWrapper = el.closest('div');
    if (el.closest('.product-form--atc')) {
      errorWrapper = el.closest('.product-form--atc');
    }
    const productFormError = document.querySelector(selectors.formError);
    if (errorWrapper && !productFormError) {
      const formError = document.createElement('p');
      formError.classList.add('tooltip', 'tooltip--top');
      formError.innerHTML = desc;
      errorWrapper.insertAdjacentElement('afterend', formError);
    } else {
      productFormError.innerHTML = desc;
    }
  }


// SHOW/HIDE PRODUCT OVERLAY
  const productOverlay = (item, status) => {
    if (status) {
      item.classList.add('is-loading');
    } else {
      item.classList.remove('is-loading');
    }
  }


// CHANGE QTY
  const checkQty = (eventType, thisInput) => {

    if (thisInput.classList.contains('sidecart-item-qty__input')) {
      let qty_min = parseInt(thisInput.min);
      let qty_max = parseInt(thisInput.max);

      if (thisInput.value.match(/[^0-9]/g)) {
        thisInput.value = thisInput.value.replace(/[^0-9]/g, '');
      }

      if( thisInput.value < qty_min ) {
        thisInput.previousElementSibling.disabled = true;
        thisInput.nextElementSibling.disabled = false;
        thisInput.value = qty_min;
      }

      if( thisInput.value > qty_max ) {
        thisInput.nextElementSibling.disabled = true;
        thisInput.previousElementSibling.disabled = false;
        thisInput.value = qty_max;
      }

      if( qty_min == qty_max ) {
        thisInput.nextElementSibling.disabled = true;
        thisInput.previousElementSibling.disabled = true;
        thisInput.value = qty_min;
      }

      if (eventType === 'change') {
        if (thisInput.value < 1) {
          thisInput.value = 1;
        }
        setTimeout(() => {
          updateProduct(thisInput.closest('.sidecart-item'));
        }, 300);
      }
    }
  }

  document.addEventListener('change', (e) => {checkQty('change', e.target)});

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('sidecart-item-qty__btn')) {
      const thisInput = e.target.closest('.sidecart-item-qty').querySelector(selectors.qtyInput);
      if (e.target.hasAttribute('data-quantity-minus')) {
        thisInput.value = --thisInput.value;
      } else if (e.target.hasAttribute('data-quantity-plus')) {
        thisInput.value = ++thisInput.value;
      }
      thisInput.dispatchEvent(new Event('change', { 'bubbles': true }));
    }
  });

  async function getCartQuantity(variantId, index = null) {
    await fetch('/cart.js')
      .then((data) => data.json())
      .then((cart)=>{
        if(index != null) {
          console.log('exact', index, cart.items[index])
          nowInCart = cart.items[index].quantity;
        } else {
          nowInCart = cart.items.reduce(function(amount, now) {
            if(now.variant_id == variantId) {
              amount += now.quantity;
            }
            return amount;
          },0);
        }
      });
    return nowInCart;
  }

// ADD PRODUCT
  const addProduct = async (event) => {
    const trainingIdInputs = document.querySelectorAll('.product-main .training-product-input--props');
    if (trainingIdInputs.length) {
      trainingIdInputs.forEach(input => {
        input.value = Date.now().toString();
      });
    }

    const thisBtn = event;
    const thisForm = event.closest('[data-product-form]');
    const productFormError = document.querySelector(selectors.formError);
    let qty_now, qty_max, qty_min;
    let selectedProductId = null;
    let nowInCart = 0;
    let config;

    thisBtn.classList.add('is-loading');

    if (productFormError) {
      productFormError.remove();
    }

    function getMinMax(quantitySelector) {
      qty_now = parseInt(quantitySelector.value) || parseInt(quantitySelector.getAttribute('min')) || 1;
      qty_max = parseInt(quantitySelector.getAttribute('max')) || 999;
      qty_min = parseInt(quantitySelector.getAttribute('min')) || 1;
    }

    async function isAddAvailable(variantId, qty_now, qty_max) {
      nowInCart = await getCartQuantity(variantId);

      return nowInCart + qty_now <= qty_max;
    }

    if (thisForm) {
      //Send via form data
      getMinMax(document.querySelector('[data-product-form] [data-quantity-input]'));
      config = {
        method: 'POST',
        headers: {
          'Accept': `application/javascript`,
          'X-Requested-With': 'XMLHttpRequest'
        }
      };
      const formData = new FormData(thisForm);
      formData.append('sections', getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const colorSelect = document.querySelectorAll('[data-color-properties]');
      if(colorSelect) colorSelect.forEach(function(color) {
        config.body.append(color.name, color.value);
      });

      const colorRadio = document.querySelectorAll('[data-color-properties-radio]:checked');
      if(colorRadio) colorRadio.forEach(function(color) {
        config.body.append(color.name, color.value);
      });

      selectedProductId = config.body.getAll('id');
    } else if (thisBtn.hasAttribute('data-variant-id')) {
      //Send via custom query
      getMinMax(thisBtn);
      const productId = thisBtn.getAttribute('data-variant-id');
      const leadTime = thisBtn.getAttribute('data-lead-time');
      const leadTimeDate = thisBtn.getAttribute('data-lead-time-date');

      config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      config.body = {
        id: productId,
        quantity: qty_min,
        sections: getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };

      config.body.properties = {}

      if (leadTime) {
        config.body.properties['Ships Out Within'] = leadTime;
      }
      if (leadTimeDate) {
        config.body.properties['Shipping Date By'] = leadTimeDate;
      }

      config.body = JSON.stringify(config.body);
      selectedProductId = productId;
    }

    if(!await isAddAvailable(selectedProductId, qty_now, qty_max)) {
      thisBtn.classList.remove('is-loading');
      showTooltip(thisBtn.parentNode, qty_max, nowInCart)
      return false;
    }

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(async (response) => {
        if (response.status === 422) {
          const formDom = document.querySelector('.product-form__grid');
          const variantDom = formDom.querySelector('.variant-selection');
          const qtyDom = formDom.querySelector('.quantity-selector__input');

          let variantId = variantDom.getAttribute('variant');
          const quantity = await getCartQuantity(variantId);

          showTooltip(formDom, qtyDom.max, quantity);

          return;
        }
        renderContents(response, true);
        openSidebar();
      })
      .catch(async (e) => {
        console.error(e);
      })
      .finally(() => {
        thisBtn.classList.remove('is-loading');
        if (document.querySelector('body').classList.contains('modal-visible')
          && event.closest('[data-modal-container]')
          && document.querySelector('.allow-scroll-while-locked .modal-close')) {
          document.querySelector('.allow-scroll-while-locked .modal-close').click();
        }
      });
  }

  const saveNote = (text) => {
    const config = {
      method: 'POST',
      headers: {
        'Accept': `application/json`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({'note': text})
    };
    fetch(`/cart/update.js`, config)
      .then((response) => response.json())
      .then((response) => {
        document.querySelector(selectors.sidebarContainer).classList.remove('order-note-opened');
      })
      .catch((e) => {
        console.error(e);
      });
  }

// UPDATE PRODUCT
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  function showTooltip(item, qty_max, nowInCart) {
    const tooltip = item.querySelector(selectors.tooltipMaximum);
    if(tooltip) {
      tooltip.classList.add('_active');
      tooltip.innerHTML = `Maximum quantity to order is <b>${ qty_max }</b>.<br>
            Now in cart: <b>${ nowInCart }</b>. ${ qty_max > nowInCart ? 'You can change quantity manualy by 1 in cart':'' }`
    }
  }

  const updateProduct = (event) => {
    const productLine = event.getAttribute('data-line-item');
    const productQty = event.querySelector(selectors.qtyInput).value;

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: productLine,
      quantity: productQty,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    productOverlay(event, true);

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        renderContents(response);
        productOverlay(event);
      })
      .catch(async (e) => {
        let variantId = event.querySelector('.sidecart-item-qty__input').getAttribute('variantid');
        const quantity = await getCartQuantity(variantId);
        const quantityExact = await getCartQuantity(variantId, productLine-1);

        event.querySelector(selectors.qtyInput).value = quantityExact;
        showTooltip(event, quantity, quantity);
        productOverlay(event);
      });
  }


// REMOVE PRODUCT
  const removeProduct = (event) => {
    const productLine = event.getAttribute('data-line-item');
    const trainingIntem = event.hasAttribute('data-training-item') ? event.getAttribute('data-training-item') : null;

    productOverlay(event, true);

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: productLine,
      quantity: 0,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (trainingIntem && response?.items) {
          const splitItem = trainingIntem.split('|');
          let trainingLine = null;

          response.items.forEach((itm, index) => {
            if (itm?.properties?._training_id === splitItem[1]) {
              trainingLine = index+1;
            }
          })

          if (trainingLine) {
            config.body = JSON.stringify({
              line: Number(trainingLine),
              quantity: 0,
              sections: getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
            });
            fetch(`${routes.cart_change_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                renderContents(response, true);
                if(response.item_count === 0) {
                  saveNote('');
                }
              })
              .catch((e) => {
                console.error(e);
              });
          } else {
            renderContents(response, true);
            if(response.item_count === 0) {
              saveNote('');
            }
          }

        } else {
          renderContents(response, true);
          if(response.item_count === 0) {
            saveNote('');
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });

  }


// RENDER CONTENTS
  window.renderContents = (parsedState, event = false) => {
    getSectionsToRender().forEach((section => {
      section.selector.forEach((selector) => {
        if (selector !== '#sidecart-related' && selector !== '#sidecart-free-shipping') {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
        if (selector === '#sidecart-related' && event === true) {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
        if (selector === '#sidecart-free-shipping' && (!document.querySelector('.sc-tag .code') || parsedState.variant_id)) {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
      })
    }));

    if (parsedState.item_count === 0 && document.querySelector('.custom-sidecart__related-product')) {
      document.querySelector('.custom-sidecart__related-product').remove();
    }

    const sidecartFooter = document.getElementById('sidecart-footer');
    if (parsedState.item_count === 0) {
      sidecartFooter.classList.add('is-empty');
    } else {
      sidecartFooter.classList.remove('is-empty');
    }
  }

  const getSectionsToRender = () => {
    return [
      {
        id: 'custom-sidecart',
        selector: ['#sidecart-products', '#sidecart-free-shipping', '#sidecart-total-value', '#sidecart-title', '#sidecart-related']
      },
      {
        id: 'static-header',
        selector: ['.site-header-cart--button']
      }
    ];
  }

  const getSectionInnerHTML = (html, selector = '.shopify-section') => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector(selector)) {
      return '';
    }
    return doc.querySelector(selector).innerHTML;
  }


// INIT SLIDER
  const relatedProductsInit = () => {
    const relatedSlider = new Swiper('.cart-also-like', {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      navigation: {
        prevEl: ".custom-sidecart__slider-nav-prev",
        nextEl: ".custom-sidecart__slider-nav-next",
      },
    })
  }


// PRODUCT RECOMMENDATIONS
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            // init "You May Also Like" slider
            relatedProductsInit();
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);


// ADD CHILD PRODUCT
  const addChildProduct = () => {
    const bundleOptionGroup = document.querySelectorAll('.product-main .product-info-group:not(.product-info-group_addons)');

    if (bundleOptionGroup !== undefined) {
      bundleOptionGroup.forEach((group) => {
        const groupFields = group.querySelectorAll('input, select');

        for (let i = 0; i < groupFields.length; i++) {
          if (groupFields[i].checked || (groupFields[i].querySelector('option') && groupFields[i].value !== '')) {
            group.classList.remove('is-error');
            const currentError = group.querySelector('.product-info-group__error');
            if (currentError) currentError.remove();
            break;
          } else {
            group.classList.add('is-error');
            showGroupError(group);
          }
        }
      });

      const errorEl = document.querySelectorAll('.product-main .product-info-group.is-error');
      if (errorEl[0]) {
        errorEl[0].scrollIntoView();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }


// VARIANT ERROR
  const showGroupError = (group) => {
    const currentError = group.querySelector('.product-info-group__error');
    const groupName = group.querySelector('.product-info-group__title') ? group.querySelector('.product-info-group__title').innerHTML + ' ' : '';
    if (!currentError) {
      group.insertAdjacentHTML('beforeend', `<p class="product-info-group__error">${groupName}is required</p>`);
    }
  }


// CLICK EVENTS
  window.addEventListener('DOMContentLoaded', () => {

    // open sidecart
    const cartBtn = document.querySelector(selectors.headerCartButton);
    if (cartBtn) {
      cartBtn.addEventListener('click', (e) => {
        openSidebar(e);
      })
    }

    // close sidecart
    const closeEl = document.querySelectorAll(selectors.closeSidebarElement);
    if (closeEl !== undefined) {
      closeEl.forEach((el) => {
        el.addEventListener('click', (e) => {
          closeSidebar(e);
        })
      })
    }

    // open/close order note
    const orderNoteBtns = document.querySelectorAll([selectors.orderNoteOpen, selectors.orderNoteClose]);
    if (orderNoteBtns) {
      orderNoteBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
          document.querySelector(selectors.sidebarContainer).classList.toggle('order-note-opened');
        })
      })
    }

    const orderNoteSaveBtns = document.querySelectorAll(selectors.orderNoteSave);
    if (orderNoteSaveBtns) {
      orderNoteSaveBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
          const noteText = document.getElementById('cart-note').value;
          saveNote(noteText);
        })
      })
    }

    document.addEventListener('click', (e) => {
      // add product to cart
      if (e.target.hasAttribute(selectors.addToSidecart) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.addToSidecart))) {
        e.preventDefault();
        e.stopPropagation();

        if (e.target.hasAttribute('disabled') || e.target.closest('button') && e.target.closest('button').hasAttribute('disabled')) {
          return false;
        }

        let dataCliaLicense = true;
        const cliaLicenseInput = document.getElementById('clia_waived_license');
        const cliaLicenseError = document.getElementById('clia_waived_license_error');
        if (e.target.hasAttribute('data-clia-license')) {
          if (cliaLicenseInput && cliaLicenseInput.value.length > 0) {
            dataCliaLicense = true;
            cliaLicenseError.classList.remove('is-error');
          } else if (cliaLicenseInput) {
            dataCliaLicense = false;
            cliaLicenseError.classList.add('is-error');
          }
        }

        let radioRequired = true;
        let radioRequiredArray = [];
        const radioRequireInput = document.querySelectorAll('#municipality, #shipping-to-end-user');
        if (e.target.hasAttribute('data-required-radio') && radioRequireInput !== undefined) {
          radioRequireInput.forEach((radio) => {
            if (radio.checked) {
              radioRequiredArray.push('1');
              radio.closest('.product-form__radion-required').classList.remove('is-error');
            } else {
              radio.closest('.product-form__radion-required').classList.add('is-error');
            }
          })

          if (radioRequiredArray.length !== radioRequireInput.length) radioRequired = false;
        }

        // add child product
        if (addChildProduct() === false) return false;

        const profBlock = document.querySelector('.product-form__professional'),
          profInput = document.querySelector('.product-form__professional-input'),
          profError = document.querySelector('.product-form__professional-error'),
          varOption = document.querySelector('#product-options'),
          varSection = document.querySelector('variant-selection'),
          varSectionInput = document.querySelector('variant-selection [data-variants]');

        if (varOption && varSection && varSectionInput) {
          if (varSection.getAttribute('variant') !== varSectionInput.value) {
            varSectionInput.value = varSection.getAttribute('variant');
          }
        }

        if (e.target.hasAttribute('data-professional') && (e.target.closest('[data-product-form]')) || e.target.closest('.product-sticky-atc') && profBlock && profInput) {
          if (profInput && profInput.checked) {
            if (profError) {
              profError.remove();
            }
            if (dataCliaLicense && radioRequired) {
              addProduct(e.target.hasAttribute(selectors.addToSidecart) ? e.target : e.target.closest('button'));
            }
          } else if (profBlock) {
            if (!profError) {
              profBlock.insertAdjacentHTML('beforeend', `<p class="product-form__professional-error">${profBlock.getAttribute('data-error-message')}</p>`)
            }
            if (e.target.closest('.product-sticky-atc')) {
              profBlock.scrollIntoView();
            }
          } else if (dataCliaLicense && radioRequired) {
            addProduct(e.target.hasAttribute(selectors.addToSidecart) ? e.target : e.target.closest('button'));
          }
        } else if (e.target.hasAttribute('data-professional-url')) {
          window.location.href = e.target.getAttribute('data-professional-url');
        } else if (dataCliaLicense && radioRequired) {
          addProduct(e.target.hasAttribute(selectors.addToSidecart) ? e.target : e.target.closest('button'));
        }

        if (!dataCliaLicense && cliaLicenseInput) cliaLicenseInput.scrollIntoView();

        if (!radioRequired && radioRequireInput !== undefined) radioRequireInput[0].scrollIntoView();
      }

      // remove product
      if (e.target.hasAttribute(selectors.removeProduct) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.removeProduct))) {
        removeProduct(e.target.closest('.sidecart-item'));
      }
    })
  });

})();
